/* KnorShot cocktail hub (kw-5b): the occasion filter. Without this file every card stays visible and the chips stay hidden. */
(function () {
  var hub = document.querySelector('[data-kc-hub]');
  if (!hub) return;
  var chips = hub.querySelector('[data-kc-chips]');
  var cards = hub.querySelectorAll('[data-kc-card]');
  var empty = hub.querySelector('[data-kc-empty]');
  if (!chips) return;
  chips.hidden = false;

  function apply(occasion) {
    var shown = 0;
    cards.forEach(function (card) {
      var match = !occasion || card.getAttribute('data-occasion') === occasion;
      card.hidden = !match;
      if (match) shown += 1;
    });
    chips.querySelectorAll('[data-occasion-chip]').forEach(function (chip) {
      var on = (chip.getAttribute('data-occasion-chip') || '') === (occasion || '');
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (empty) empty.hidden = shown !== 0;
  }

  chips.addEventListener('click', function (event) {
    var chip = event.target.closest('[data-occasion-chip]');
    if (chip) apply(chip.getAttribute('data-occasion-chip'));
  });
  if (empty) {
    var reset = empty.querySelector('[data-kc-reset]');
    if (reset) reset.addEventListener('click', function () { apply(''); });
  }
})();
